import { render, staticRenderFns } from "./GenericView.vue?vue&type=template&id=cc2e326a"
import script from "./GenericView.vue?vue&type=script&lang=js"
export * from "./GenericView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports